import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const orderApi = createApi({
    reducerPath:"orderApi" , 
    baseQuery : fetchBaseQuery({
        baseUrl : import.meta.env.VITE_API + "order",
        prepareHeaders : (headers , {getState}) => {
            const token = getState().userSlice?.token ;
            if (token) {
                headers.set("Authorization", `bearer ${token}`)
            }
            headers.set("Content-Type", "application/json")
            return headers ;
        }
    }),
    endpoints : (builder) => ({
        getOrderHistory : builder.query({
            query : () => ({
                url:"/history?page=1&no_of_docs_each_page=10" ,
                method : "GET"
            })
        }),
        // get order
        getOrder : builder.query({
            query : () => ({
                url:"" ,
                method : "GET"
            })
        }),
        // update address
        updateAddressOrder : builder.mutation({
            query : ({adCode , orderCode}) => ({
                url : `/set_address?address_code=${adCode}&order_code=${orderCode}` ,
                method : "PATCH"
            })
        }),
        // set dis
        setDiscountOrder :  builder.mutation({
            query : ({discountCode,orderCode}) => ({
                url : `/set_discount?off_code=${discountCode}&order_code=${orderCode}` ,
                method : "PATCH"
            })
        }),
        //  gate payment
        setGateTypeOrder :  builder.mutation({
            query : ({gateCode,orderCode}) => ({
                url : `/set_gateway_type?gateway_type_code=${gateCode}&order_code=${orderCode}` ,
                method : "PATCH"
            })
        }),
        // delivery type
         setDeliveryOrder :  builder.mutation({
            query : ({deliveryCode,orderCode}) => ({
                url : `/set_delivery_type?delivery_type_code=${deliveryCode}&order_code=${orderCode}` ,
                method : "PATCH"
            })
        }),
    })
})
export const {useGetOrderHistoryQuery , useGetOrderQuery , useUpdateAddressOrderMutation , useSetDiscountOrderMutation , useSetGateTypeOrderMutation , useSetDeliveryOrderMutation} = orderApi